import CONTENT_STRINGS from '../../src/helpers/contentStrings';

export const TEXT_CONFIRM_SOLICITOR_GROUP_UPDATE = "Yes - update all policies that have gone live since __date__ with the new underwriter";

export const TEXT_DECLINE_SOLICITOR_GROUP_UPDATE = "No - do not update existing policies, the change will only apply to new policies";

export const INFO_TEXT_EDIT_WITH_APPROVAL = "Edit with approval";

export const INFO_TEXT_EDIT_WITHOUT_APPROVAL = "Edit without approval";

export const APPLICATION_POLICY_VIEW = 'application-and-policies/application-policy';
export const COUNTRY = process.env.REACT_APP_COUNTRY;

export const CANADA_COUNTRY = "CA";
export const UK_COUNTRY = "UK";
export const isCanada = COUNTRY === CANADA_COUNTRY ? true : false;
//TODO : this will be replaced in the future and the values will be taken from the API
export const PERCENTAGE_PREMIUMS_AVAILABLE = process.env.REACT_APP_PERCENTAGE_PREMIUMS_AVAILABLE === 'true' ? true : false;
export const ARAG_USER_CAN_SUBMIT_UPDATE_FORM = process.env.REACT_APP_ARAG_USER_CAN_SUBMIT_UPDATE_FORM === 'true' ? true : false;
export const COMMENT_AREA_INFO_MESSAGE = "Please be aware, any text bracketed by the following symbols <strong><u>< ></u></strong> will not appear in the comment.";
export const LEGAL_ADVICE_TEXT = COUNTRY == UK_COUNTRY ? "Solicitor" : "Lawyer";
export const TARGET_SUB_SETTINGS = 'stagesSubSettings';
export const TARGET_SUB_AGENT_LIST =  'agentCommissionsList';
export const TARGET_COMMISSION =  'commissionPercentage';
export const TARGET_UNDERWRITER =  'underwriterRatePercentage';
export const AVERAGE_EXPECTED_PREMIUM =  'averageExpectedPremium';
export const FLAT_PREMIUM_SETTINGS = 'flat';
export const STAGED_PREMIUM_SETTINGS = 'staged';
export const STAGED_PREMIUM_EDIT = 'stagedEdit';
export const LOADER = 'loader';
export const NONE = 'none';
export const PREMIUM_SETTINGS_DEFAULT_TABS = [
	{ key: CONTENT_STRINGS.CUSTOM.toLowerCase(), label: CONTENT_STRINGS.CUSTOM },
	{ key: CONTENT_STRINGS.DEFAULT.toLowerCase(), label: CONTENT_STRINGS.DEFAULT },
] ;	
export const PREMIUM_SETTINGS_TABS = COUNTRY == CANADA_COUNTRY ?
		PREMIUM_SETTINGS_DEFAULT_TABS.concat([{ key: CONTENT_STRINGS.STAGED.toLowerCase(), label: CONTENT_STRINGS.STAGED }]) :
		(PERCENTAGE_PREMIUMS_AVAILABLE ? PREMIUM_SETTINGS_DEFAULT_TABS.concat([{ key: CONTENT_STRINGS.PERCENTAGE.toLowerCase(), label: CONTENT_STRINGS.PERCENTAGE }]) : PREMIUM_SETTINGS_DEFAULT_TABS);
export const PREMIUM_SETTINGS_CHECKBOX_OPTIONS = [
	{
		label: CONTENT_STRINGS.STAGED,
		id: STAGED_PREMIUM_SETTINGS,
	},
	{
		label: CONTENT_STRINGS.FLAT,
		id: FLAT_PREMIUM_SETTINGS,
	},
];
 export const POLICYHOLDER_TEXT = COUNTRY == UK_COUNTRY ? "Client" : "Plaintiff";

 export const LEGAL_ACTION = COUNTRY == UK_COUNTRY ? "Recourse" : "Plaintiff Cost Solutions";
 
 export const CURRENCY = COUNTRY == UK_COUNTRY ? '£' : '$';

 export const PERCENTAGE_SYMBOL = '%';

 export const CURRENCY_MENU_OPTIONS = [{ sign: '£', code: 'GBP' }, { sign: '$', code: 'CAN' }];

 export const CURRENCY_CA = '$';

 export const CURRENCY_CODE = COUNTRY == UK_COUNTRY ? 'GBP' : 'CAN';

 export const CURRENCY_CODE_UK = 'GBP';

 export const CURRENCY_CODE_CA = 'CAN';

 export const TOBA_PATH = COUNTRY == CANADA_COUNTRY ? "useragreement" : "toba";

 export const TOBA_FULL_TEXT = COUNTRY == CANADA_COUNTRY ? "User Agreement" : "Terms Of Business Agreement";
 
 export const TOBA_SHORT_TEXT= COUNTRY == CANADA_COUNTRY ? "User Agreement" : "TOBA";
 
 export const CURRENCYCLASSNAME = COUNTRY == UK_COUNTRY ? 'poundInput' : 'dolarInput';

 export const ARAG_POLICY_TYPE= "ESS";
 
export const DEFAULT_OPPONENT = {
	name: '',
	prospectsOptionId: '',
	insuredOptionId: '',
	satisfiedOptionId: '',
	insurerOptionId: '',
	otherInsurerName:'',
	otherInsurerId:'',
	NameOfInsurerOther: ''	
};

// maps questionMachineName to opponent column names
export const APPLICATION_OPPONENT_ENUM = {
	IsOpponentInsured: "InsuredId",
	OpponentNotInsuredSatisfiedHasFunds: "SatisfiedId",
	OpponentDoNotKnowInsuredSatisfiedHasFunds: "SatisfiedId",
	OpponentName: "Name",
	ProspectsAgainstOpponent: "ProspectsId",
	WhoIsTheInsurer: "InsurerId",
	OtherInsurerName: "OtherInsurerName",
	NameOfInsurerOther: "OtherInsurerId",
};

// maps fees column names to dto
export const MEDICAL_EXPERT_FEES_ENUM = {
	Name: {name: "Name"},
	NatureOfExpert: {name: "Nature of Expert"},
	WhySpecificExpert: {name: "Why Specific Expert"},
	BreachCausationCpId: {name: "Breach/Causation/CP"},
	BreachCausationCp: {name: "Breach/Causation/CP"},
	PartialEstimatedCost: {name: "Estimated Cost of Report"},
	AttendanceEstimatedCost: {name: "Estimated Cost of Attendance at Final Hearing"},
};

export const DEFAULT_MEDICAL_EXPERT_FEE = {
	name: '',
	natureOfExpert: '',
	whySpecificExpert: '',
	breachCausationCpId: '',
	partialEstimatedCost: '',
	attendanceEstimatedCost: ''
};

export const ANSWER_UPDATE_TYPE = {
	APPLICATION: "Application",
	APP_OPPONENT: "Opponent",
	APP_MED_EXP_FEES: "MedicalExpertFees",
	QUESTION: "Question"
};

export const ANSWER_UPDATE_ACTION = {
	ADD: "Add",
	REMOVE: "Remove",
	UPDATE: "Update"
};

export const WORK_SOURCE_EDIT_WARNING = "Editing this field may impact the premium amount";

export const WORK_SOURCE_EDIT_MESSAGE = "Please note, due to a request to change the work source the premium on the policy schedule may be incorrect. Please contact ATE Underwriting on 0117 917 1564";

export const APPLICATION_FORM_CLIENT_NAME = `${POLICYHOLDER_TEXT} Name`;

export const APPLICATION_FORM_FIELDS = {
	SOLICITOR_REFERENCE: {
		fieldName: "SolicitorReference",
		name: `${LEGAL_ADVICE_TEXT} File Reference`,
		fakeQuestion: {
			id: "solicitorReference",
			machineName: "solicitorReference",
			name: "Solicitor Reference",
			inputType: 'text',
			isStandard: true,
			options: []
		}
	},
	CLIENT_NAME: {
		fieldName: "ClientName",
		name: COUNTRY == CANADA_COUNTRY ? `${APPLICATION_FORM_CLIENT_NAME} (Last name, First name)` : APPLICATION_FORM_CLIENT_NAME,
		fakeQuestion: {
			id: "clientName",
			machineName: "clientName",
			name: "Client Name",
			inputType: 'text',
			isStandard: true,
			options: []
		}
	},
	ADDRESS: {
		fieldName: "Address",
		name: COUNTRY == CANADA_COUNTRY ? "Address (# Street, City)" : "Address",
		fakeQuestion: {
			id: "address",
			machineName: "address",
			name: "Address",
			inputType: 'text',
			isStandard: true,
			options: []
		}
	},
	POST_CODE: {
		fieldName: "PostCode",
		name: COUNTRY != CANADA_COUNTRY ? "PostCode" : "Postal Code",
		fakeQuestion: {
			id: "postCode",
			machineName: "postCode",
			name: "Postcode",
			inputType: 'text',
			isStandard: true,
			options: []
		}
	},
	DATE_OF_BIRTH: {
		fieldName: "DateOfBirth",
		name: "Date of Birth",
		fakeQuestion: {
			id: "dateOfBirth",
			machineName: "dateOfBirth",
			name: "Date Of Birth",
			inputType: 'calendar',
			isStandard: true,
			options: []
		}
	},
	WORK_SOURCE: {
		fieldName: "WorkSourceId",
		name: "Work source",
		fakeQuestion: {
			id: "workSourceId",
			machineName: "workSourceId",
			name: "Work source",
			inputType: 'drop down',
			isStandard: true,
			options: []
		}
	},
	// Marianna: I am adding these to be used in the solicitor auto-generated spec
	APPLICATION_ANSWERS: {
		fieldName: "ApplicationAnswers",
		name: " - ",
		fakeQuestion: {
			id: "applicationAnswers",
			machineName: "applicationAnswers",
			name: " - ",
			inputType: 'array',
			isStandard: true,
			options: []
		}
	},
	APPLICATION_MEDICAL_EXPERT_FEES: {
		fieldName: "ApplicationMedicalExpertFees",
		name: "Please provide an estimate for your medical experts fees",
		fakeQuestion: {
			id: "applicationMedicalExpertFees",
			machineName: "applicationMedicalExpertFees",
			name: "Please provide an estimate for your medical experts fees",
			inputType: 'array',
			isStandard: false,
			condition: 'This is required in case the corresponding question in the Application answers data sub-structure table is required',
			options: []
		}
	},
	APPLICATION_OPPONENTS: {
		fieldName: "ApplicationOpponents",
		name: "Name of Opponent",
		fakeQuestion: {
			id: "applicationOpponents",
			machineName: "applicationOpponents",
			name: " - ",
			inputType: 'array',
			isStandard: false,
			condition: 'This is required in case the corresponding question (OpponentName) in the Application answers data sub-structure table is required',
			options: []
		}
	},
	CONFIRMED: {
		fieldName: "Confirmed",
		name: "Confirmed",
		fakeQuestion: {
			id: "confirmed",
			machineName: "confirmed",
			name: "Confirmed",
			inputType: 'boolean',
			isStandard: false,
			condition: 'Required if there is another application/policy with the same combination of solicitorReference, clientName and postCode.\n ' +
				'Note: a confirmation shall be needed to explain why this is not a duplicate of the existing one - This is indicating that a confirmation is being provided',
			options: []
		}
	},
	CONFIRMATION: {
		fieldName: "Confirmation",
		name: "Confirmation",
		fakeQuestion: {
			id: "confirmation",
			machineName: "confirmation",
			name: "Confirmation",
			inputType: 'text',
			isStandard: false,
			condition: 'Required if Confirmed = True',
			options: []
		}
	},
	ATTACHMENTS: {
		fieldName: "Attachments",
		name: " - ",
		fakeQuestion: {
			id: "attachments",
			machineName: "attachments",
			name: " - ",
			inputType: 'array',
			isStandard: false,
			condition: 'Required if the Application Answer specifies a file upload; Optional if not',
			options: []
		}
	},
	WORK_SOURCE_NAME: {
		fieldName: "WorkSourceName",
		name: "Work source",
		fakeQuestion: {
			id: "workSourceName",
			machineName: "workSourceName",
			name: "Work source",
			inputType: 'text',
			isStandard: false,
			condition: 'No',
			options: []
		}
	},
	CASE_TYPE: {
		fieldName: "CaseType",
		name: "Case Type",
		fakeQuestion: {
			id: "caseType",
			machineName: "caseType",
			name: "Case Type",
			inputType: 'drop down',
			isStandard: true,
			options: []
		}
	},
	SUB_CASE_TYPE: {
		fieldName: "SubCaseType",
		name: "Sub Case Type",
		fakeQuestion: {
			id: "subCaseType",
			machineName: "subCaseType",
			name: "Sub Case Type",
			inputType: 'drop down',
			isStandard: false,
			condition: ' - ',
			options: []
		}
	},
};

export const mockData = [
	'retailer',
	'coffee',
	'shop',
];

export const mockData2 = [
	'negligence',
	'accident',
];

export const mockData3 = [
	'building',
	'box',
	'bottle',
	'cup',
	'screen',
	'book',
];

export const PLEASE_UPLOAD_REMISSION_MESSAGE = 'Please upload Remission Application Form or Calculator EX160C';

export const NOT_FOUND_MESSAGE = "No record found";

export const POLICY_NOT_READY_FOR_CLAIMS_MESSAGE = "This policy is not yet ready for claims processing. Please try again once setup is complete.";
// US 101077: must match SolicitorTransferResult.BudNotifyFailedError - shown when the policy itself
// carries the failed flag, i.e. on a visit later than the transfer that caused it.
export const TRANSFER_NOT_REFLECTED_MESSAGE = "The policy transfer was not fully applied and there might be issues on other systems. Please contact IT.";

export const ADVANCE_DISBURSEMENTS_PROCESSING_FILTER_STATUS_MACHINE_NAME = 'processing';

export const AD_STATUS_PART_SETTLED_MACHINE_NAME = 'part-settled';

export const AD_STATUS_PAID_MACHINE_NAME = 'paid';

export const ADVANCE_DISBURSEMENTS_PAID_PART_SETTLED_STATUSES = [AD_STATUS_PART_SETTLED_MACHINE_NAME, AD_STATUS_PAID_MACHINE_NAME];

export const ADVANCE_DISBURSEMENTS_TRANSITIONAL_STATUS = "Processing";

export const INVALID_DATES_ERROR_MESSAGE = 'Date inputs are not valid (DD/MM/YYYY).';

export const ItemTypes = {
	CARD: "card"
};

export const CUSTOM_AUTOSUGGEST_INPUT_STYLE = {
    container: 'agents-list-action-autoSuggest-container',
    input: 'applicationsAndPolicies-autosuggest',
    suggestionsContainer: 'applicationsAndPolicies-autosuggest-suggestionsContainer',
    suggestionsList: 'applicationsAndPolicies-autosuggest-suggestionsList',
    suggestion: 'applicationsAndPolicies-autosuggest-suggestion',
    suggestionHighlighted: 'applicationsAndPolicies-autosuggest-suggestion-highLighted'
};

export const DROPZONE_ACCEPTED_FILES = '.pdf, .doc, .docx, .xls, .xlsx, .jpg, image/jpeg, image/jpg, .msg, .bmp, .png, .txt, .eml, .dot';

export const DROPZONE_ACCEPTED_FILES_ARRAY = ['.pdf', '.doc', '.docx', '.xls', '.xlsx',' .jpg',' image/jpeg', 'image/jpg', '.msg', '.bmp', '.png', '.txt', '.eml', '.dot'] ;

export const FLOAT_REGEX = /^\d{1,15}((\.|,)\d{1,2})?$/g ;

export const POLICY_LINK_TO_POLICY_TAB_LOOKUP_TABLE = {
	policyschedule: 'policySchedule',
	overview: 'overview',
    wording: 'policySchedule',
    ipid: 'policySchedule',
	update: 'update',
	documents: 'documents',
	advanceDisbursements: 'advancedDisbursements',
	application: 'application',
};

export const ADMIN_USERS = ['Administrator'];

export const SOLICITOR_USERS = ['Solicitor'];

export const AGENTS_USERS = ['Solicitor', 'Broker'];

export const ARAG_USERS = ['User','Underwriter', 'Technical Underwriter', 'Medical Expert'];

export const TABLE_VIEW_OPTIONS = [
    {key: '20', value: 20},
    {key: '50', value: 50},
    {key: '100', value: 100},
    {key: '150', value: 150},
    {key: '200', value: 200}
];

export const UI_LIB_TABLE_VIEW_OPTIONS = [
    {key: '20', label: 20},
    {key: '50', label: 50},
    {key: '100', label: 100},
    {key: '150', label: 150},
    {key: '200', label: 200}
];

export const  ACCEPTED_UPLOAD_FILES = '.pdf, .doc, .docx, .xls, .xlsx, .jpg, .msg, .bmp, .png, .txt, .eml';

export const DATE_REGEX_DD_MM_YYYY = "^(0[1-9]|[12][0-9]|3[01])[\\/\\-](0[1-9]|1[012])[\\/\\-]\\d{4}$";

export const DATE_REGURAL_EXPRESSION = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;